import {
    PENDING_UPDATE_BULK_STORE, SUCCESS_UPDATE_BULK_STORE, ERROR_UPDATE_BULK_STORE, PENDING_UPDATE_PASSWORD, SUCCESS_UPDATE_PASSWORD, ERROR_UPDATE_PASSWORD
} from "../actions/types";

const initialState = {
    store_list: [],
};
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case PENDING_UPDATE_BULK_STORE:
            return {
                ...state,
                pending_bulk_update: true,
                error_bulk_update: null
            }
        case SUCCESS_UPDATE_BULK_STORE:
            return {
                ...state,
                bulk_update: action.payload && action.payload.data && action.payload.data?.count ? action.payload?.data?.count : [],
                pending_bulk_update: false,
                error_bulk_update: null
            }

        case ERROR_UPDATE_BULK_STORE:
            return {
                ...state,
                error_bulk_update: action?.payload,
                pending_bulk_update: false,
            }
        case PENDING_UPDATE_PASSWORD:
            return {
                ...state,
                pending_update_password: true,
                error_update_password: null
            }
        case SUCCESS_UPDATE_PASSWORD:
            return {
                ...state,
                update_password: action.payload?.data?.data?.user ? action.payload?.data?.data?.user : [],
                pending_update_password: false,
                error_update_password: null
            }

        case ERROR_UPDATE_PASSWORD:
            return {
                ...state,
                error_update_password: action?.payload,
                pending_update_password: false,
            }

        default:
            return state
    }
}